import { render, staticRenderFns } from "./tarih.vue?vue&type=template&id=117db3e4&"
import script from "./tarih.vue?vue&type=script&lang=js&"
export * from "./tarih.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports